import { formatBytes } from "./utils";

export const TABS = {
  overview: "overview",
  details: "details",
};

export const METADATA_OVERVIEW_COLUMN = [
  {
    dataIndex: "domain",
    key: "domain",
    title: "Domain",
    sorter: true,
  },
  {
    dataIndex: "data_source",
    key: "data_source",
    title: "Data Source",
    sorter: true,
  },
  {
    dataIndex: "record_count",
    key: "record_count",
    title: "Record Count",
    sorter: true,
  },
  {
    dataIndex: "size",
    key: "size",
    title: "Size",
    sorter: true,
    render: bytes => formatBytes(bytes),
  },
  {
    dataIndex: "business_stewards",
    key: "business_stewards",
    title: "Business Steward(s)",
    sorter: true,
  },
  {
    dataIndex: "technical_stewards",
    key: "technical_stewards",
    title: "Technical Steward(s)",
    sorter: true,
  },
];

export const METADATA_DETAILS_COLUMN = [
  {
    dataIndex: "data_source",
    key: "data_source",
    title: "Data Source",
    sorter: true,
  },
  {
    dataIndex: "critical_data_element",
    key: "critical_data_element",
    title: "Critical Data Element",
    sorter: true,
  },
  {
    dataIndex: "source_schema",
    key: "source_schema",
    title: "Source Schema",
    sorter: true,
  },
  {
    dataIndex: "source_table",
    key: "source_table",
    title: "Source Table",
    sorter: true,
  },
  {
    dataIndex: "source_column",
    key: "source_column",
    title: "Source Column",
    sorter: true,
  },
];
